module.exports = __webpack_public_path__ + "static/widgets_7-96f5670ac6ff1d224e327c211f97c216.png";